declare namespace $ {

	type $shm_showcase_demo_list_page_items__1 = $mol_type_enforce<
		`Документы`
		,
		string
	>
	type $shm_showcase_demo_list_page_items__2 = $mol_type_enforce<
		`Изображения`
		,
		string
	>
	type $shm_showcase_demo_list_page_items__3 = $mol_type_enforce<
		`Заметки`
		,
		string
	>
	type $mol_paragraph__title_shm_showcase_demo_list_page_4 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_list_page['row_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $shm_showcase_demo_list_page extends $shm_list_page {
		add_handler( ): any
		rows( ): readonly($mol_view)[]
		row_title( id: any): string
		title( ): string
		add( ): ReturnType< $shm_showcase_demo_list_page['add_handler'] >
		body( ): ReturnType< $shm_showcase_demo_list_page['rows'] >
		items( next?: readonly(string)[] ): readonly(string)[]
		Row( id: any): $mol_paragraph
	}
	
}

//# sourceMappingURL=page.view.tree.d.ts.map